import _ from 'lodash';
import * as d3 from 'd3';
/**
 * This function is called to render a graphic by Pym.js. The frame's width and
 * a reference to the Pym instance is provided.
 *
 * @param  {Number} [frameWidth=600] The current width of the iframe, defaults
 *                                   to 600px to help with development
 * @param  {Object} pymChild         A reference to the IFrame's Pym instance
 * @return {void}
 */


let data = d3.nest()
	.key(d => d['name'])
	.entries(window.DATA.votes_missed)
  .filter(d => ['Ted Cruz', 'Beto O\'Rourke'].includes(d['key']))

let margin = {top: 20, bottom: 20, right: 5, left: 30}
const chart = barchart()
const el = d3.select('#graphic')
const wrapPoint = 450
let width = 0
let height = 0
let chartWidth = 0
let chartHeight = 0
let barHeight = 0



function resizeDb() {
  console.log("resizing")
  const graphic = document.getElementById("graphic")
  const bbox = graphic.getBoundingClientRect()
  const { width } = bbox;
  const height = window.innerWidth > wrapPoint ? width/2 : width
  window.innerWidth > wrapPoint ? chart.width(width/2).height(height) : chart.width(width).height(height)
  el.call(chart)
}

window.addEventListener('resize', () => { 
  _.debounce(() => {
    resizeDb()
  }, 400)
});



const xScale = d3.scaleBand()
const yScale = d3.scaleLinear()
const colorScale = d3.scaleOrdinal()

const formatPercent = d3.format(",.0%")
const formatLabel = d3.format(",.1%")
const parseYear = d3.timeParse('%Y')
const formatYear = d3.timeFormat('’%y')

function barchart() {
    
  function enter({ container, data }) {
    const divEnter = container.selectAll('.bar-div').data(data)
      .enter()
      .append("div")
      .attr("class", "bar-div")

    divEnter.append("p").attr("class", "chart-title").text(d => `${d.key.split(" ").pop()}'s absence rate`)
    const svgEnter = divEnter.append("svg").attr("class", "bar-svg")

    const gEnter = svgEnter.append('g')

    gEnter.append("g").attr("class", "annotations")
    gEnter.append("g").attr("class", "y-axis axis")
    gEnter.append("g").attr("class", "x-axis axis")
    gEnter.append("g").attr("class", "bars")
    
  }

  function updateScales({ container, data }) {

    colorScale
      .domain(['Ted Cruz', 'Beto O\'Rourke'])
      .range(['#d74947', '#1775b0'])

    //const xExtent = d3.extent(_.flatten(data.map(arr => d3.extent(arr.values, d => parseYear(d.year)))), d => d)
    const xExtent = data[0].values.map(d => parseYear(d.year))
    xScale 
      .domain(xExtent)
      .rangeRound([0, chartWidth])
      .padding(0.4)

    yScale
      .domain([0, 0.5])
      .rangeRound([chartHeight, 0])
      .nice()

    const svg = container.selectAll('.bar-div').selectAll(".bar-svg")
    const g = svg.select('g')

    const xAxisG = g.select(".x-axis")
    const yAxisG = g.select(".y-axis")

    const xAxis = d3.axisBottom(xScale)
      .tickFormat(formatYear)
      .ticks(6)

    const yAxis = d3.axisLeft(yScale)
      .tickFormat(formatPercent)
      .tickSize(-chartWidth)
      .ticks(6)
    
    const xAxisGEnter = xAxisG
      .attr('transform', `translate(0, ${chartHeight})`)
      .call(xAxis)

    const yAxisGEnter = yAxisG
      .attr('transform', 'translate(0, 0)')
      .call(yAxis)

    xAxisGEnter.select(".domain").remove();
    yAxisGEnter.select(".domain").remove();
    yAxisGEnter.selectAll(".tick:first-of-type text").remove()

    const yLabel = yAxisG.selectAll(".tick:last-of-type").selectAll(".y-label").data([" of votes missed"])
    const yLabelEnter = yLabel
      .enter()
      .append("text")
      .attr("class", "y-label")
    .merge(yLabel)
      .text(d => d)
      .attr("dy", "0.32em")

    const yLabelWidth = yLabelEnter._groups[0][0].getBoundingClientRect().width
    yAxisG.selectAll(".tick:last-of-type line").attr("x1", yLabelWidth + 5)




  }

  function updateDom({ container, data }) {
      const svg = container.selectAll(".bar-div").selectAll(".bar-svg")
      svg
        .attr('width', width)
        .attr('height', height)

      const g = svg.select('g')

      g.attr('transform', `translate(${margin.left}, ${margin.top})`)

      const bars = g.select(".bars")



      const barG = bars.selectAll(".bar-g")
        .data(d => d.values)

      const barGEnter = barG
        .enter()
        .append("g")
        .attr("class", "bar-g")
      .merge(barG)

      barGEnter
        .append("rect")
        .attr("class", "bar-rect")

      barGEnter
        .filter(d => d['year'] == '2018' || (d['name'] == 'Ted Cruz') && (d['year'] == '2015' || d['year'] == '2016'))
        .append("text")
        .attr("class", "bar-text")

      const barGUpdate = barGEnter.merge(barG)

      barGUpdate
        .select(".bar-rect")
        .attr("x", d => xScale(parseYear(d.year)))
        .attr("y", d => yScale(d['pct_votes_missed']))
        .attr("width", xScale.bandwidth())
        .attr("height", d => chartHeight - yScale(d['pct_votes_missed']))
        .attr("fill", d => colorScale(d.name))

      barGUpdate
        .select(".bar-text")
        .attr("x", d => xScale(parseYear(d.year)) + xScale.bandwidth()/2)
        .attr("y", d => yScale(d['pct_votes_missed']) - chartHeight/100)
        .text(d => formatLabel(d['pct_votes_missed']))


  }


  function chart(container) {
    const data = container.datum()
    enter({ container, data })
    updateScales({ container, data })
    updateDom({ container, data })
  }

  chart.width = function(...args) {
    if (!args.length) return width
    width = args[0]
    chartWidth = width - margin.left - margin.right
    return chart
  }

  chart.height = function(...args) {
    if (!args.length) return height
    height = args[0]
    chartHeight = height - margin.top - margin.bottom
    return chart
  }
  return chart
}

function init() {
  el.datum(data)
  resizeDb()
}






export default function renderGraphic(frameWidth, pymChild) {
  // Any code neccessary to render your graphic should be placed here - this
  // function is what is called in main.js by Pym
  console.log("i am being called here!")
  init()
}
